import React, { Fragment, Component } from 'react';
import { getStyles } from '../../../shared/utility';

import DateTimePicker from '../../../components/UI/DateTimePicker/DateTimePicker';

import localStyles from './DateTime.scss';
const styles = getStyles(localStyles);

class DateTime extends Component {
    constructor(props) {
        super(props);

        this.dateInputs = ['date', 'start', 'end', 'min', 'max', 'earliest', 'latest'];

        const state = {
            type: 'datetime',
            range: true,
            minRange: 'P2D',
            maxRange: 'P5D',
            stepsize: undefined,
            roundStepsize: undefined,
            outputFormat: 'iso'
        };
        const refs = {};

        this.dateInputs.forEach(input => state[input] = undefined);
        state.min = new Date(2018, 6, 1, 0, 0, 0, 0);
        state.max = new Date(2018, 6, 31, 0, 0, 0, 0);
        Object.keys(state).forEach(input => refs[input] = React.createRef());

        this.state = state;
        this.ref = refs;
    }

    change = () => {
        const newState = {};
        Object.entries(this.ref).forEach(input => {
            const el = input[1].current;
            if(!el){
                return;
            }
            newState[input[0]] = el.type === 'checkbox' ? el.checked : !isNaN(new Date(el.value)) ? new Date(el.value) : el.value ? el.value : undefined;
        });


        if(Object.keys(newState).length){
            this.setState(newState);
        }
    }

    render() {
        const props = this.state;
        props.callback = (output) => {console.log(output);};

        const cd = styles('d');
        const ci = styles('i');
        const cdf = styles('d', 'f');

        return (
            <Fragment>
                <h4>Test datetime pickers</h4>

                <div className={styles('content', 'content--padding-vertical')}>
                    <div className={styles('flex', 'flex--justify-between')}>
                        <div className={styles('col', 'col--100', 'col__s--50')}>
                            <h5>Picker</h5>
                            <DateTimePicker {...props} />
                        </div>
                        <div className={styles('col', 'col--100', 'col__s--50')}>
                            <h5>Settings</h5>
                            <div className={styles('flex', 'flex--justify-between', 'flex--wrap')}>
                                <fieldset className={cd}>
                                    <label className={cdf} htmlFor="datetime-type">Type</label>
                                    <select className={cdf} id="datetime-type" ref={this.ref.type} onChange={this.change} defaultValue={this.state.type}>
                                        <option value={'datetime'}>datetime</option>
                                        <option value={'date'}>date</option>
                                        <option value={'time'}>time</option>
                                    </select>
                                </fieldset>
                                <fieldset className={cd}>
                                    <label className={cdf} htmlFor="outputformat-type">Output</label>
                                    <select className={cdf} id="outputformat-type" ref={this.ref.outputFormat} onChange={this.change} defaultValue={this.state.outputFormat}>
                                        <option value={'iso'}>iso</option>
                                        <option value={'date'}>date</option>
                                        <option value={'timestamp'}>timestamp</option>
                                    </select>
                                </fieldset>
                                <fieldset className={cd}>
                                    <label className={cdf} htmlFor="datetime-range">
                                        <input type="checkbox" className={ci} id="datetime-range" ref={this.ref.range} onChange={this.change} defaultChecked={this.state.range}/> Range
                                    </label>
                                </fieldset>
                                <fieldset className={cd}>
                                    <label className={cdf} htmlFor="datetime-minRange">minRange</label>
                                    <input type="text" className={cdf} id="datetime-minRange" ref={this.ref.minRange} onChange={this.change} defaultValue={this.state.minRange?this.state.minRange:''}/>
                                </fieldset>
                                <fieldset className={cd}>
                                    <label className={cdf} htmlFor="datetime-maxRange">maxRange</label>
                                    <input type="text" className={cdf} id="datetime-maxRange" ref={this.ref.maxRange} onChange={this.change} defaultValue={this.state.maxRange?this.state.maxRange:''}/>
                                </fieldset>
                                <fieldset className={cd}>
                                    <label className={cdf} htmlFor="datetime-stepsize">stepsize</label>
                                    <input type="text" className={cdf} id="datetime-stepsize" ref={this.ref.stepsize} onChange={this.change} defaultValue={this.state.stepsize?this.state.stepsize:''}/>
                                </fieldset>
                                <fieldset className={cd}>
                                    <label className={cdf} htmlFor="datetime-roundStepsize">
                                        <input type="checkbox" className={ci} id="datetime-roundStepsize" ref={this.ref.roundStepsize} onChange={this.change} defaultChecked={this.state.roundStepsize}/> roundStepsize
                                    </label>
                                </fieldset>
                                {this.dateInputs.map(input => (
                                    <fieldset key={input} className={cd}>
                                        <label className={cdf} htmlFor={`datetime-${input}`}>{input}</label>
                                        <input type="datetime-local" className={ci} id={`datetime-${input}`} ref={this.ref[input]} onChange={this.change} defaultValue={this.state[input] ? this.state[input].toISOString().substr(0,16) : ''}/>
                                    </fieldset>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>

            </Fragment>
        );
    }
}

export default DateTime;



// WEBPACK FOOTER //
// ./src/containers/Test/DateTime/DateTime.js